import { render, staticRenderFns } from "./WalletCardProduct.vue?vue&type=template&id=3b7af979&scoped=true&"
import script from "./WalletCardProduct.vue?vue&type=script&lang=js&"
export * from "./WalletCardProduct.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardProduct.vue?vue&type=style&index=0&id=3b7af979&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7af979",
  null
  
)

export default component.exports